import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { DealActionBarContainer as o, DealActionBarItem as t, SkeletonVoteButton as i, SkeletonCommentLink as a, SkeletonLink as l } from "../style.js";
function k({
  className: n
}) {
  return /* @__PURE__ */ r(o, { className: n, children: [
    /* @__PURE__ */ e(t, { children: /* @__PURE__ */ e(i, { animate: !0 }) }),
    /* @__PURE__ */ e(t, { children: /* @__PURE__ */ e(a, { animate: !0 }) }),
    /* @__PURE__ */ e(t, { children: /* @__PURE__ */ e(l, { animate: !0 }) })
  ] });
}
export {
  k as DealActionBarHeaderSkeleton
};
